import { Pipe, PipeTransform } from '@angular/core';

import { JackpotValueSerializer } from './jackpot-value-serializer.service';
import { JackpotValueModel } from './jackpot-value.model';

@Pipe({
    name: 'csJackpotValueFormatter',
    standalone: true,
    pure: true,
})
export class JackpotValueFormatterPipe implements PipeTransform {
    constructor(private readonly valueSerializer: JackpotValueSerializer) {}

    transform(value: JackpotValueModel | undefined, withCurrency: boolean, currencyOnRight: boolean, withAmount: boolean) {
        return this.valueSerializer.serialize(value, withCurrency, currencyOnRight, withAmount);
    }
}
